export const rudderstackIdentify = (userId: string): void => {
  if (!global.window.rudderstackUserLoaded) {
    global.window.rudderstackUserLoaded = true
    global.window?.rudderanalytics?.identify(userId)
  }
}
